import React from "react";

interface ErrorStateProps {
  message: string;
}

const ErrorState: React.FC<ErrorStateProps> = ({ message }) => (
  <div className="flex items-center justify-center py-8 text-destructive">
    <span className="mr-2">❌</span>
    <span>{message}</span>
  </div>
);

export default ErrorState;
